import type { DeepWritable } from '@cmg/common';
import { getDataSource } from '@cmg/data-grid';
import { useMemo } from 'react';

import type { InvestorCoverageRow } from '../InvestorCoverageGrid.model';
import { useSalesCoverage_UnderwriterEmployeeInvestorCoverage } from './useSalesCoverageUnderwriterEmployeeInvestorCoverageQuery';

type UseInvestorCoverageGridDataSourceParams = {
  tenantId?: string;
  employeeId: string;
};

export function useInvestorCoverageGridDataSource({
  tenantId,
  employeeId,
}: UseInvestorCoverageGridDataSourceParams) {
  const loadRows = useSalesCoverage_UnderwriterEmployeeInvestorCoverage(tenantId);

  return useMemo(() => {
    return getDataSource({
      getData: async variables => {
        const { data, error } = await loadRows({
          employeeId,
          where: variables.where,
          order: variables.order,
        });
        if (error) {
          throw error;
        }

        const rowData = (data?.underwriterEmployees?.items?.[0]?.salesCoverage ??
          []) as DeepWritable<InvestorCoverageRow[]>;
        const rowCount = rowData.length;

        return {
          rowData,
          rowCount,
        };
      },
    });
  }, [loadRows, employeeId]);
}
